export default __webpack_public_path__ + "static/media/mediaTypeGoogle.8dad678d.svg";